const WIX = (id, w = 1200, h = 800, q = 88) =>
  `https://static.wixstatic.com/media/${id}/v1/fill/w_${w},h_${h},al_c,q_${q},enc_auto/${id}`;

export const IMAGES = {
  hero: WIX("862de4_f340fa2637314262a69dacb6913e8c53~mv2.png", 2200, 1400, 90),
  landscape: WIX("862de4_7327c0aec0b14657a3ed7fac5cf1031e~mv2.png", 2200, 1200, 90),
  servicesHero: WIX("862de4_c764b4534d30499ab8ed2ecbbf4eb5c8~mv2.png", 2200, 1240, 90),
  servicesAbout: WIX("862de4_b1b2df7701b64de99bf514cb0d936682~mv2.png", 1000, 1250, 88),
  experiencesHero: WIX("862de4_ff3e6c4dedcc4e068e8cd123e85c1e90~mv2.png", 2200, 1240, 90),
  premium: [
    WIX("862de4_dc31b8aeb80540b7a8a768e531298b2c~mv2.png", 768, 576, 88),
    WIX("862de4_9481ce1459ae4f7c823251951ed41aab~mv2.png", 768, 576, 88),
    WIX("862de4_c9a507fe30ea4889a87897553b1b9835~mv2.png", 768, 576, 88),
    WIX("862de4_2876f41468224a719d886f1a3f681bb1~mv2.png", 768, 576, 88),
  ],
  properties: [
    {
      name: "Villa Petra",
      image: "https://cdn.krossbooking.com/ogstay/images/3/12/17832466469096.webp",
    },
    {
      name: "Villa Libera",
      image: "https://cdn.krossbooking.com/ogstay/images/3/11/17825064459037.webp",
    },
  ],
  experiences: [
    WIX("862de4_305c08110aa3468e9adb7004e71ec3da~mv2.png", 900, 700, 88),
    WIX("862de4_8cf96594e9e647109851d534442591bf~mv2.png", 900, 700, 88),
    WIX("862de4_463961bbad5a4f7c9338e8620d75e1e5~mv2.png", 900, 700, 88),
  ],
};

export const LOGO = "/ogstay-logo-trimmed.png";
export const LOGO_LIGHT = "/ogstay-logo-light.png";

export const LINKS = {
  booking: "https://ogstay.kross.travel/",
  ownerPortal: "https://vr.krossbooking.com/ogstay/",
  whatsapp: "https://wa.me/393711200518",
  phone: "tel:+393711200518",
  googleBusiness: "https://share.google/nDs2ijx9Q8ff5lqNc",
};

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const imgUrl = (ref) => {
  if (!ref) return "/ogstay-logo.png";
  return ref.startsWith("http") ? ref : `${API}/files/${ref}`;
};

// ---------- Booking engine (Kross) — source of truth unica ----------
// Parametri verificati sul gestionale: from=YYYY-MM-DD, to=YYYY-MM-DD, guests=N, kross_lang=it|en
export const KROSS_AVAILABILITY = "https://ogstay.kross.travel/book/step1";

export const propertyUrl = (property) => property?.external_booking_url || LINKS.booking;

export const bookingSearchUrl = ({ checkin, checkout, guests, lang } = {}) => {
  const params = new URLSearchParams();
  if (checkin) params.set("from", checkin);
  if (checkout) params.set("to", checkout);
  if (guests) params.set("guests", String(guests));
  params.set("kross_lang", lang === "en" ? "en" : "it");
  const qs = params.toString();
  return `${KROSS_AVAILABILITY}?${qs}`;
};

// ---------- Analytics (dataLayer GA4-ready, no-op finché GA4 non è attivo) ----------
export const trackEvent = (event, params = {}) => {
  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, ...params });
  } catch {
    /* noop */
  }
};
